import { createFileRoute, useNavigate } from '@tanstack/react-router'
import Login from '~containers/samsung.smart-things/login'

export const Route = createFileRoute('/samsung/smart-things/(guest)/login/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, string>) => search,
})

function RouteComponent() {
  const navigate = useNavigate()
  const searchParams = Route.useSearch()

  return (
    <Login
      state={searchParams.state}
      otp={searchParams.otp}
      onSuccess={() => {
        navigate({
          from: '/samsung/smart-things/login',
          to: '/samsung/smart-things',
          replace: true,
          resetScroll: true,
        })
      }}
    />
  )
}
